import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppUiModule } from '../../ui/app-ui.module';
import { EsasSocketRoutingModule } from './esas-socket-routing.module';
import { EsasSocketComponent } from './esas-socket.component';

@NgModule({
  declarations: [EsasSocketComponent],
  imports: [CommonModule, EsasSocketRoutingModule, FormsModule, ReactiveFormsModule, AppUiModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EsasSocketModule {}
